import PropTypes from 'prop-types';
import { useBoolean } from 'usehooks-ts';
import { Button } from '@mui/material';

import { useBreakpointFlags } from 'hooks/useBreakpointFlags';

const styles = {
  button: { width: 260 },
};

const DownloadSnapshotButton = ({ onDownloadSnapshot }) => {
  const { isMdDown: isMobile } = useBreakpointFlags();
  const { value: isDownloading, setTrue: startDownloading, setFalse: stopDownloading } = useBoolean();

  const handleDownloadSnapshot = async () => {
    startDownloading();

    try {
      await onDownloadSnapshot();
    } catch (error) {
      stopDownloading();

      throw error;
    }

    stopDownloading();
  };

  if (isMobile) {
    return null;
  }

  return (
    <Button className="remove_for_pdf" loading={isDownloading} sx={styles.button} onClick={handleDownloadSnapshot}>
      Download Snapshot
    </Button>
  );
};

DownloadSnapshotButton.propTypes = {
  onDownloadSnapshot: PropTypes.func.isRequired,
};

export default DownloadSnapshotButton;
